<template id="mapTmpl">
		<ct-main-layout-appadmin :backurl="backurl" :breadcrumbs="breadcrumbs" >
			
			<v-card>
				<!-- TITLE -->
				<v-card-title>
					{{ this.detailMap.map_name }}
				</v-card-title>

				<v-card-text>
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{ $t('lbl.organization')}}: {{detailOrg.organization_name}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{ $t('lbl.site')}}: {{detailSite.site_name}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{ $t('lbl.mapAssetType')}}:</strong> {{decodeMapAssetType(this.detailMap.map_asset_type)}}
						</v-col>
					</v-row>
					<v-row no-gutters v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type != 'only_values'">
						<v-col cols="12">
							<strong>{{ $t('lbl.mapAsset')}}:</strong> {{this.detailMap.map_asset}}
						</v-col>
					</v-row>
				</v-card-text>
				
				<v-divider></v-divider>
				
				<v-card-text>	
					<v-row no-gutters>
						<v-col cols="12">
							<v-btn class="button-main ma-1" v-on:click="openEditMap()"><v-icon left dark>create</v-icon>{{ $t('btn.edit')}}</v-btn>
							
							<v-btn class="button-main ma-1" v-on:click="openAddPoiDialog()"><v-icon left dark>add</v-icon>{{ $t('btn.addPoi')}}</v-btn>

							<v-btn class="button-main ma-1" v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'image'" v-on:click="gotoMapRenderingImage()" ><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderImage')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'render3d_pro'" v-on:click="gotoMapRendering3d()" ><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderShin')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'render3d_basic'" v-on:click="gotoMapRendering3d()" ><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderShin')}}</v-btn>
							<v-btn class="button-main ma-1" v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'threejs'" v-on:click="gotoMapRenderTheejs()"><v-icon left dark>desktop_windows</v-icon>{{$t('btn.loadMapRenderThreeJs')}}</v-btn>

							<v-btn class="button-main ma-1" v-if="detailMap != null && !isEmptyString(detailMap.map_link)" v-on:click="openMapLink(detailMap.map_link)" ><v-icon left dark>list_alt</v-icon>{{ $t('btn.mapLink')}}</v-btn>
						</v-col>
					</v-row>
				</v-card-text>

				<v-divider></v-divider>
			
				<!-- RENDERS -->
				<div class="mb-2" v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type != 'only_values'">
					
					<!-- DIALOG RENDERING 3D-->
					<ct-map-dlg-render-shin 
					ref="renderShin" 
					></ct-map-dlg-render-shin>

					<!-- DIALOG RENDER THREE JS-->
					<ct-map-dlg-render-threejs 
					ref="renderThreeJs" 
					:orgid="this.$route.params.orgId" 
					:siteid="this.$route.params.siteid" 
					:mapDetailObj="detailMap"
					printMouse="true"
					></ct-map-dlg-render-threejs>

					<!-- DIALOG RENDER IMAGE-->
					<ct-map-dlg-render-image
					ref="renderImage" 
					:orgid="this.$route.params.orgId" 
					:siteid="this.$route.params.siteid" 
					:mapDetailObj="detailMap"
					></ct-map-dlg-render-image>

				</div>

				<!-- POIS LIST -->	
				<ct-map-poi-list ref="poiList" :orgid="$root.$route.params.orgId" :siteid="$root.$route.params.siteid" :mapitem="detailMap" :poilist="poilist"></ct-map-poi-list>
			</v-card>	

			<!-- MIDDLEWARE -->
			<v-card class="mb-2">
				
				<v-card-title>{{$t('lbl.middleware')}}</v-card-title>

				<v-card-text v-if="detailMap != null && detailMap.map_asset_type != null && (detailMap.map_asset_type == 'render3d_pro' || detailMap.map_asset_type == 'render3d_basic')">
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{$t('lbl.middlewareShin3dCalls')}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayPoiListS3d()" >{{$t('btn.gatewayPoiListShin')}}</v-btn>
						</v-col>
					</v-row>	
				</v-card-text>

				<v-card-text v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'threejs'" >
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{$t('lbl.middlewareThreeJsCalls')}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{$t('lbl.directoryRepositoryFileObj')}}: {{mapObjRepository}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayConfigCallThreejs()" >{{$t('btn.gatewayConfigCallThreejs')}}</v-btn>
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayPoiListThreejs()" >{{$t('btn.gatewayPoiListThreejs')}}</v-btn>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-text v-if="detailMap != null && detailMap.map_asset_type != null && detailMap.map_asset_type == 'image'">
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{$t('lbl.middlewareRenderImage')}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayPoiListRenderImage()" >{{$t('btn.gatewayPoiListRenderImage')}}</v-btn>
						</v-col>
					</v-row>	
				</v-card-text>

				<v-card-text>
					<v-row no-gutters>
						<v-col cols="12">
							<strong>{{$t('lbl.middlewareCommonCalls')}}</strong>
						</v-col>
					</v-row>
					<v-row no-gutters>
						<v-col cols="12">	
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayPoisImgsList()" >{{$t('btn.gatewayPoisImgsList')}}</v-btn>
						</v-col>	
						<v-col cols="12">	
							<v-btn class="button-secondary ma-1" v-on:click="gotoGatewayPoiListAlert()" >{{$t('btn.gatewayPoiListWithAlert')}}</v-btn>
						</v-col>
					</v-row>
				</v-card-text>

			</v-card>

			<ct-dialog-edit-map ref="editMapDlg" :map2edit="detailMap"></ct-dialog-edit-map>

		</ct-main-layout-appadmin>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

import ctMapPoiList from "@/components/appadmin/ctMapPoiList.vue";
import ctDialogRenderShin from "@/components/commons/ctDialogRenderShin.vue";
import ctDialogRenderThreeJs from "@/components/commons/ctDialogRenderThreeJs.vue";
import ctDialogRenderImage from "@/components/commons/ctDialogRenderImage.vue";
import ctDialogEditMap from '@/components/appadmin/ctDialogEditMap.vue';

export default {
	i18n,
	data: () => ({
		backurl: null,
		breadcrumbs:[],
		detailOrg: null,
		detailSite: null,
		detailMap: null,
		poilist: [],
		mapObjRepository: '',
	}),
	created() 
	{
		events.$on('reloadPoiList', () => {
			this.loadPoiList();
		});
		this.mapObjRepository = constants.ENDPOINT_REPOSITORY_THREEJS;
		this.detailOrg = this.getEmptyOrgGuiAdmin();
		this.detailSite = this.getEmptySite();
		this.detailMap = this.getEmptyMap();
	},
	destroyed() 
	{
		events.$off('reloadPoiList');
	},
	mounted() 
	{
		//=== BLOCCO LA PAGINA
		this.$root.globalPageLoading = true;

		//=== NAVIGATION BAR
		this.backurl = '/appadmin/site/' + this.$root.$route.params.orgId +'/'+  this.$root.$route.params.siteid;
		this.breadcrumbs = [
			{ text: i18n.t('breadcrumb.appadmin'), disabled: false, href: '/tools/appadmin' }
		];

		//=== STARTUP
		this.loadOrgDetails();
	},
	components: {
		'ct-map-poi-list': ctMapPoiList,
		'ct-map-dlg-render-shin': ctDialogRenderShin,
		'ct-map-dlg-render-threejs': ctDialogRenderThreeJs,
		'ct-map-dlg-render-image': ctDialogRenderImage,
		'ct-dialog-edit-map': ctDialogEditMap, 
	},
	methods: {
		createDefaultNewObjMap() {
			var result = { map_asset: '', map_asset_type: '', map_name: '', site_id: this.$route.params.siteid, sitemap_id: '',
				"transform": { "position": { "x": 0, "y": 0, "z": 0 }, "rotation": { "x": 0, "y": 0, "z": 0, "w": 0 }, "scale": {"x": 0, "y": 0, "z": 0 } }
			};
			return result;
		},
		loadOrgDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadOrgDetails, 'err.loadingOrg');
			}
		},
		callbackLoadOrgDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailOrg = responseData;

				this.breadcrumbs.push({text: this.detailOrg.organization_name, disabled: false, href: '/tools/appadmin/organization/'+ this.$route.params.orgId });

				this.loadSiteDetails();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingOrg"));
			}		
		},
		loadSiteDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites/'+ this.$route.params.siteid;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadSiteDetails, 'err.loadingSite');
			} 
		},
		callbackLoadSiteDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailSite = responseData;

				this.breadcrumbs.push({text: this.detailSite.site_name, disabled: false, href: '/tools/appadmin/site/' + this.$root.$route.params.orgId +'/'+  this.$root.$route.params.siteid});

				this.loadMapDetails();
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingSite"));
			}
		},
		loadMapDetails() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else 
			{
				var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites/'+ this.$route.params.siteid +'/maps/' +this.$route.params.mapid;
				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadMapDetails, 'err.loadingMap');
			} 
		},
		callbackLoadMapDetails(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.detailMap = responseData;

				this.breadcrumbs.push({text: this.detailMap.map_name, disabled: false});
				
				this.loadPoiList(); 
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingMap"));
			}
		},	
		loadPoiList() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyObj(this.detailMap) || (!this.isEmptyObj(this.detailMap) && this.isEmptyString(this.detailMap.sitemap_id)))
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else 
			{
				//var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites/'+ this.$route.params.siteid +'/maps/' +this.$route.params.mapid + '/pois';
				
				var endpoint2go = constants.ENDPOINT_GATEWAY_POI_LIST_ALERT;
				endpoint2go += "?org=" + this.$route.params.orgId;
				endpoint2go += "&site=" + this.$route.params.siteid;
				endpoint2go += "&map=" + this.detailMap.sitemap_id;

				this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadPoiList, 'err.loadingPois');
			}
		},
		callbackLoadPoiList(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				this.poilist = this.getSecurePoiList(responseData, false);
				
				//=== SBLOCCO LA PAGINA
				this.$root.globalPageLoading = false;
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingPois"));
			}	
		},	
		gotoMapRendering3d() 
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else 
			{
				// CHIUDO IL RENDERING 3D
				this.$refs.renderShin.closeMapRenderShin();
				this.$refs.renderShin.openMapRenderShin(this.$route.params.orgId, this.$route.params.siteid, this.detailMap);
			}
		},	
		gotoGatewayPoiListS3d()
		{
			
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			} else {
				var url2go = constants.ENDPOINT_GATEWAY_POI_S3D_LIST;
				url2go += "?org=" + this.$route.params.orgId;
				url2go += "&site=" + this.$route.params.siteid;
				url2go += "&map=" + this.$route.params.mapid;
				url2go += "&accessToken=" + this.getUserAccessToken();
				window.open(url2go);
			}
		},
		gotoGatewayPoiListThreejs()
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			var url2go = constants.ENDPOINT_GATEWAY_POI_TJS_LIST;
			url2go += "?org=" + this.$route.params.orgId;
			url2go += "&site=" + this.$route.params.siteid;
			url2go += "&map=" + this.$route.params.mapid;
			url2go += "&accessToken=" + this.getUserAccessToken();
			window.open(url2go);
		},
		gotoGatewayConfigCallThreejs()
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			var url2go = constants.ENDPOINT_GATEWAY_POI_TJS_MAP_CONFIG;
			url2go += "?org=" + this.$route.params.orgId;
			url2go += "&site=" + this.$route.params.siteid;
			url2go += "&map=" + this.$route.params.mapid;
			url2go += "&accessToken=" + this.getUserAccessToken();
			window.open(url2go);
		},
		gotoGatewayPoiListRenderImage()
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			var url2go = constants.ENDPOINT_GATEWAY_RENDER_IMAGE_POI_LIST;
			url2go += "?org=" + this.$route.params.orgId;
			url2go += "&site=" + this.$route.params.siteid;
			url2go += "&map=" + this.$route.params.mapid;
			url2go += "&accessToken=" + this.getUserAccessToken();
			window.open(url2go);
		},
		gotoGatewayPoisImgsList()
		{
			window.open(constants.ENDPOINT_GATEWAY_BKG_IMG_LIST);
		},
		gotoMapRenderTheejs() 
		{
			this.$refs.renderThreeJs.openMapRenderThreeJs();
		},
		gotoMapRenderingImage() 
		{
			this.$refs.renderImage.openMapRenderImage();
		},
		gotoGatewayPoiListAlert()
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			} 
			else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t("err.siteSelectedNotValid"));
			}
			else if(this.isEmptyString(this.$route.params.mapid))  
			{
				this.$root.setDialogMsg(i18n.t('err.mapSelectedNotValid'));
			}
			else 
			{
				var url2go = constants.ENDPOINT_GATEWAY_POI_LIST_ALERT;
				url2go += "?org=" + this.$route.params.orgId;
				url2go += "&site=" + this.$route.params.siteid;
				url2go += "&map=" + this.$route.params.mapid;
				url2go += "&accessToken=" + this.getUserAccessToken();
				//=== ACCESS TOKEN PRIMA LO CERCA NEGLI HEADERS SE NON LO TROVA LO CERCA IN GET
				window.open(url2go);
			}
		},
		openEditMap()
		{
			this.$refs.editMapDlg.openEditMap();
		},
		openAddPoiDialog()
		{
			this.$refs.poiList.openAddPoiDialog();
		},
		openMapLink(link)
		{
			window.open(link,'_blank');
		},
	}
}
</script>